import { Row, Col } from "react-bootstrap";
import "./WhyTeams.css";
import { useState } from "react";
import PopupModal from "../../components/Modal/PopupModal";

const WhyTeamsPrefer = ({ title, highlight, buttonLabel }) => {
  const [getPopUpShow, setPopUpShow] = useState(false);
  const onhide = () => {
    setPopUpShow(false);
  };
  const handelclick = () => {
    setPopUpShow(true);
  };

  return (
    <>
      <div className="cta-section">
        <Row className="align-items-center">
          {/* IMAGE LEFT */}
          <Col md={6} className="text-center">
            <img
              src="/assets/images/vensapdash.png"
              alt="Why teams prefer VENSAP"
              className="why-image"
            />
          </Col>

          {/* TEXT RIGHT */}
          <Col md={6} className="text-col">
            <h2 className="why-title">
              {title} <span>{highlight}</span>
            </h2>

            <div className="cta-button-wrapper-why">
              <button className="main-btn" onClick={handelclick}>
                {buttonLabel}
              </button>
            </div>
          </Col>
        </Row>
      </div>
      <PopupModal show={getPopUpShow} onHide={onhide} />
    </>
  );
};

export default WhyTeamsPrefer;
